import styles from "./loading.module.scss";

const Loading = () => {
    return (
        <div className={styles.loadingContainer}>
            <div>Loading...</div>
        </div>
    );
}
export default Loading